"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M14.616 1.684a.5.5 0 0 0-.707 0l-2.121 2.122a.5.5 0 0 0 0 .707l2.12 2.121a.5.5 0 1 0 .708-.707L13.269 4.58c1.264.07 2.558.68 3.63 1.56a7.5 7.5 0 0 1-4.592 13.295.5.5 0 0 0 .022 1 8.5 8.5 0 0 0 5.204-15.068c-1.146-.942-2.606-1.67-4.113-1.78l1.196-1.196a.5.5 0 0 0 0-.707M5.127 8.059a.5.5 0 0 0-.666.237 8.5 8.5 0 0 0-.779 2.808.5.5 0 0 0 .995.098c.086-.866.32-1.703.687-2.478a.5.5 0 0 0-.237-.666m-.842 5.469a.5.5 0 0 0-.353.613 8.5 8.5 0 0 0 1.142 2.52.5.5 0 1 0 .831-.556 7.5 7.5 0 0 1-1.008-2.223.5.5 0 0 0-.612-.354m6.012 6.211a.5.5 0 0 0-.333-.624 7.5 7.5 0 0 1-2.554-1.358.5.5 0 0 0-.631.776 8.5 8.5 0 0 0 2.895 1.54.5.5 0 0 0 .623-.334"
}), 'RotateLeft');
//# sourceMappingURL=index.js.map